/**
 * Generated by orval v7.14.0 🍺
 * Do not edit manually.
 * Adobe Photoshop API
 * This is the comprehesive reference for the Adobe Photoshop API, including all available API endpoints, request formats, parameters, authentication requirements, and example responses to use when integrating with or building on top of our APIs.
 * OpenAPI spec version: 1.0
 */
/**
 * Any errors reported in the requested output.
 */
export interface JobError {
  /** The error type. */
  type?: string;
  /** The error code. */
  code?: string;
  /** The error description. */
  title?: string;
  /** The internal error code. */
  error_code?: string;
  /** The details of the error returned. */
  details?: ErrorDetails[];
}

/**
 * Any errors reported in the requested output.
 */
export interface InputValidationError {
  /** The error type. */
  type?: string;
  /** The error code. */
  code?: string;
  /** The error description. */
  title?: string;
  /** The details of the error returned. */
  details?: InputValidationErrorDetail[];
}

/**
 * Any errors reported in the requested output.
 */
export interface TrialLimitExceededError {
  /** The error type. */
  type?: string;
  /** The error code. */
  code?: string;
  /** The error description. */
  title?: string;
  /** The details of the error returned. */
  details?: string;
}

/**
 * Details of the input validation error returned.
 */
export interface InputValidationErrorDetail {
  /** The name of the input parameter. */
  allowedValues?: string;
  /** The reason for the error. */
  reason?: string;
}

/**
 * A file located on Adobe's cloud or a supported external service.
 */
export interface StorageDetails {
  /** A pre-signed GET URL. */
  href: string;
  storage: StorageType;
}

/**
 * Color space for output image
 */
export interface SenseiColor {
  space?: ColorSpaceType;
}

/**
 * Color space for output image
 */
export type ColorSpaceType = (typeof ColorSpaceType)[keyof typeof ColorSpaceType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ColorSpaceType = {
  rgb: 'rgb',
  rgba: 'rgba',
} as const;

/**
 * A PNG file.
 */
export interface SenseiOutputDetails {
  /** A pre-signed POST URL to the output file. */
  href: string;
  storage: StorageType;
  mask?: MaskFormat;
  color?: SenseiColor;
  /** If the file already exists, indicates if the output file should be overwritten. Will eventually support eTags. Only applies to CC Storage. */
  overwrite?: boolean;
}

export interface SenseiJobApiResponse {
  /** The job ID requested. */
  jobId?: string;
  /** Created timestamp of the job (YYYY-DD-MMThh:mm:ss.mmmmmZ). */
  created?: string;
  /** Modified timestamp of the job (YYYY-DD-MMThh:mm:ss.mmmmmZ). */
  modified?: string;
  status?: JobStatus;
  output?: SenseiOutputDetails;
  errors?: JobError;
  _links?: JobStatusLink;
}

export interface JobStatusLink {
  self?: SelfLink;
}

export interface RemoveBackgroundRequest {
  input: StorageDetails;
  output: SenseiOutputDetails;
}

export interface CreateMaskRequest {
  input: StorageDetails;
  output: SenseiOutputDetails;
}

export interface JobStatusLinkResponse {
  _links?: JobStatusLink;
}

export interface IccProfileDetails {
  imageMode?: ImageModeType;
  input?: StorageDetails;
  profileName?: ColorProfileType;
}

/**
 * An output object.
 */
export interface SmartObjectOutputDetails {
  /** A pre-signed POST URL to the output file. */
  href: string;
  storage: StorageType;
  type: ImageFormatType;
  /** If the file already exists, indicates if the output file should be overwritten. Will eventually support eTags. Only applies to CC Storage. */
  overwrite?: boolean;
  /** The width, in pixels, of the renditions. A width of 0 generates a full size rendition. Height is generated automatically using the aspect ratio. Only supported for image rendition. */
  width?: number;
  /**
   * The quality of the renditions for JPEG. The range is 1 to 7, 7 being the highest quality.
   * @minimum 1
   * @maximum 7
   */
  quality?: number;
  compression?: CompressionType;
}

/**
 * An output object.
 */
export interface ActionOutputDetails {
  /** A pre-signed POST URL to the output file. */
  href: string;
  storage: StorageType;
  type: ImageFormatType;
  /** If the file already exists, indicates if the output file should be overwritten. Will eventually support eTags. Only applies to CC Storage. */
  overwrite?: boolean;
  /**
   * The quality of the renditions for JPEG. The range is 1 to 7, 7 being the highest quality.
   * @minimum 1
   * @maximum 12
   */
  quality?: number;
  compression?: CompressionType;
}

/**
 * An output object.
 */
export interface PsOutputDetails {
  /** A pre-signed POST URL to the output file. */
  href: string;
  storage: StorageType;
  type: ImageFormatType;
  /** If the file already exists, indicates if the output file should be overwritten. Will eventually support eTags. Only applies to CC Storage. */
  overwrite?: boolean;
  /** The width, in pixels, of the renditions. A width of 0 generates a full size rendition. Height is generated automatically using the aspect ratio. Only supported for image rendition. */
  width?: number;
  /** The size, in pixels, of the renditions. When width is 0, maxWidth can be provided to get the rendition size. maxWidth when less than document width gets precedence over width. Height is not necessary as the rendition generate will automatically maintain the aspect ratio. */
  maxWidth?: number;
  /**
   * The quality of the renditions for JPEG. The range is 1 to 7, 7 being the highest quality.
   * @minimum 1
   * @maximum 7
   */
  quality?: number;
  compression?: CompressionType;
  trimToCanvas?: TrimToCanvasType;
  /** An array of layer objects.
By including this array you are signaling that you'd like a rendition created from these layer id's or layer names. Excluding it will generate a document-level rendition. */
  layers?: LayerReference[];
  iccProfile?: IccProfileDetails;
}

/**
 * A rendition object.
 */
export interface RenditionLinkDetails {
  /** The rendition location. */
  href?: string;
  storage?: StorageType;
  /** The requested rendition width in pixels. */
  width?: number;
  type?: ImageFormatType;
}

export interface ManifestJobApiResponse {
  /** The job ID requested. */
  jobId?: string;
  /** The outputs requested. */
  outputs?: ManifestJobStatusOutputDetails[];
  _links?: JobStatusLink;
}

export interface PsJobApiResponse {
  /** The job ID requested. */
  jobId?: string;
  /** API output details. */
  outputs?: JobOutputDetails[];
  _links?: JobStatusLink;
}

/**
 * Photoshop Job response.
 */
export type PsJobResponse = ManifestJobApiResponse | PsJobApiResponse;

export type DocumentManifestRequestOptions = DocumentManifestOptions & unknown;

export interface DocumentManifestRequest {
  /** An array of input objects. Each input object represents a file to be processed. */
  inputs: StorageDetails[];
  options?: DocumentManifestRequestOptions;
}

export interface LayerPosition {
  insertAbove?: LayerReference;
  insertBelow?: LayerReference;
  insertInto?: LayerReference;
  insertTop?: boolean;
  insertBottom?: boolean;
}

/**
 * Indicates you want to delete the layer, identified by the `id` or `name`. Note the object is currently empty but leaves room for further enhancements.
 */
export interface DeleteDetails {
  /** Indicates that child layers are included when deleting a group layer. */
  includeChildren?: boolean;
  /** The layer ID. */
  id?: number;
  /** The layer name. You can identify a layer by id or name. That makes either id or name a required field. */
  name?: string;
}

/**
 * A layer reference object.
 */
export interface LayerReference {
  /** The id of the layer. Use either `id` OR `name`. */
  id?: number;
  /** The name of the layer. Use either `id` OR `name`. */
  name?: string;
}

export interface CreateDocumentRequest {
  /** An array of output objects. Each output object represents a file to be created. */
  outputs: PsOutputDetails[];
  options: DocumentCreateOptions;
}

export interface ModifyDocumentRequest {
  /** An array of input objects. Each input object represents a file to be processed. */
  inputs: StorageDetails[];
  /** An array of output objects. Each output object represents a file to be created. */
  outputs: PsOutputDetails[];
  options: DocumentOperationOptions;
}

export interface CreateRenditionRequest {
  /** An array of input objects. Only one input object is currently supported. */
  inputs: StorageDetails[];
  /** An array of output objects. */
  outputs: PsOutputDetails[];
}

export interface ReplaceSmartObjectRequest {
  /** An array of input objects. Only one input object is currently supported. */
  inputs: StorageDetails[];
  /** An array of output objects. */
  outputs: SmartObjectOutputDetails[];
  options: SmartObjectOptions;
}

export interface PlayPhotoshopActionsRequest {
  /** An array of input objects. Only one input object is currently supported. */
  inputs: StorageDetails[];
  /** An array of output objects. */
  outputs: ActionOutputDetails[];
  options: ActionOptions;
}

export interface PlayPhotoshopActionsJsonRequest {
  /** An array of input objects. Only one input object is currently supported. */
  inputs: StorageDetails[];
  /** An array of output objects. */
  outputs: ActionOutputDetails[];
  options: ActionJsonOptions;
}

export interface ConvertToActionsJsonRequest {
  /** An array of input action sets in ATN format. Only one input object is currently supported. */
  inputs: StorageDetails[];
  options?: ActionJsonCreateOptions;
}

export interface ApplyAutoCropRequest {
  /** An array of input objects. Only one input object is currently supported. */
  inputs: StorageDetails[];
  /** An array of output objects */
  outputs: ActionOutputDetails[];
  options: CropOptions;
}

export interface ApplyDepthBlurRequest {
  /** An array of input objects. We currently only support one input object */
  inputs: StorageDetails[];
  /** An array of output objects */
  outputs: ActionOutputDetails[];
  options?: DepthBlurDetails;
}

export interface EditTextLayerRequest {
  /** An array of input objects. We currently only support one input object */
  inputs: StorageDetails[];
  /** An array of output objects */
  outputs: ActionOutputDetails[];
  options: TextOptions;
}

export interface CreateArtboardRequest {
  options: ArtboardDetails;
  /** An array of output objects */
  outputs: PsOutputDetails[];
}

export interface DocumentDetails {
  /** In pixels */
  height: number;
  /** In pixels */
  width: number;
  /**
   * In pixels per inch
   * @minimum 72
   * @maximum 300
   */
  resolution: number;
  fill: FillType;
  mode: ChannelModeType;
  depth?: DepthType;
}

export interface ManifestJobDocumentDetails {
  /** The name of the document */
  name?: string;
  /** In pixels */
  height?: number;
  /** In pixels */
  width?: number;
  /** The version of Photoshop used to create the document */
  photoshopBuild?: string;
  imageMode?: ImageModeType;
  bitDepth?: ChannelModeType;
  /** The name of the ICC profile used for the document */
  iccProfileName?: string;
}

export interface ChildrenLayerDetails {
  /** The layer ID. An ID of -1 is valid and indicates a PSD that only contains a background image and no layers. */
  id?: number;
  /** The layer index. */
  index?: number;
  /** If thumbnails were requested, a pre-signed GET URL to the thumbnail */
  thumbnail?: string;
  type?: LayerType;
  /** The layer name. */
  name?: string;
  /** Whether the layer is locked */
  locked?: boolean;
  /** Whether the layer is visible */
  visible?: boolean;
  adjustments?: AdjustmentDetails;
  bounds?: Bounds;
  blendOptions?: BlendDetails;
  mask?: LayerMaskDetails;
  smartObject?: SmartObjectDetails;
  fill?: FillDetails;
  text?: TextLayerDetails;
}

export interface LayerDetails {
  /** The layer ID. An ID of -1 is valid and indicates a PSD that only contains a background image and no layers. */
  id?: number;
  /** The layer index. */
  index?: number;
  /** If thumbnails were requested, this is a pre-signed GET URL to the thumbnail. */
  thumbnail?: string;
  /** An array of nested layer objects. Only layerSections (group layers) can include children. */
  children?: ChildrenLayerDetails[];
  type?: LayerType;
  /** The layer name. */
  name?: string;
  /** Whether the layer is locked. */
  locked?: boolean;
  /** Whether the layer is visible. */
  visible?: boolean;
  adjustments?: ManifestJobAdjustmentDetails;
  bounds?: Bounds;
  blendOptions?: BlendDetails;
  mask?: LayerMaskDetails;
  smartObject?: SmartObjectDetails;
  fill?: FillDetails;
  text?: TextLayerDetails;
}

export type ActionStorage = StorageType & unknown;

/**
 * An object describing the input Photoshop Actions to play.
 */
export interface Action {
  storage?: ActionStorage;
  /** Presigned GET URL */
  href?: string;
  /** If you only want to execute a particular action, you may specify which action to play from the ActionSet */
  actionName?: string;
}

/**
 * Details of Actions from the ActionSet.
 */
export interface ActionDetails {
  /** If you only want to execute a particular action, you may specify whcih action to convert from the ActionSet */
  actionName?: string;
}

/**
 * Adjustment layer information.
 */
export interface AdjustmentDetails {
  brightnessContrast?: BrightnessContrast;
  exposure?: ExposureDetails;
  hueSaturation?: HueSaturation;
  colorBalance?: ColorBalance;
}

/**
 * Adjustment layer information.
 */
export interface ManifestJobAdjustmentDetails {
  brightness_contrast?: BrightnessContrast;
  exposure?: ExposureDetails;
  hue_saturation?: HueSaturation;
  color_balance?: ColorBalance;
}

/**
 * Brightness and contrast settings.
 */
export interface BrightnessContrast {
  /**
   * The adjustment layer's brightness.
   * @minimum -150
   * @maximum 150
   */
  brightness?: number;
  /**
   * The adjustment layer's contrast.
   * @minimum -150
   * @maximum 150
   */
  contrast?: number;
}

/**
 * Exposure settings.
 */
export interface ExposureDetails {
  /**
   * The layer's exposure.
   * @minimum -20
   * @maximum 20
   */
  exposure?: number;
  /**
   * The layer's offset.
   * @minimum -0.5
   * @maximum 0.5
   */
  offset?: number;
  /**
   * The layer's gamma correction.
   * @minimum 0.01
   * @maximum 9.99
   */
  gammaCorrection?: number;
}

export interface HueSaturation {
  /** Whether to colorize. */
  colorize?: boolean;
  /** An array of hashes representing the 'master' channel (the remaining five channels of 'magentas', 'yellows', 'greens', etc. are not yet supported). */
  channels?: ChannelDetails[];
}

/**
 * Color balance settings.
 */
export interface ColorBalance {
  /** Whether to preserve luminosity. */
  preserveLuminosity?: boolean;
  /** Shadow levels. */
  shadowLevels?: number[];
  /** Midtone levels. */
  midtoneLevels?: number[];
  /** Highlight levels. */
  highlightLevels?: number[];
}

/**
 * The bounds of the layer.
 */
export interface Bounds {
  /** The top position in pixels. */
  top?: number;
  /** The left position in pixels. */
  left?: number;
  /** The width in pixels. */
  width?: number;
  /** The height in pixels. */
  height?: number;
}

/**
 * Character style settings.
 */
export interface CharacterStyleDetails {
  /**
   * The font size, in pixels.
   * @minimum 0.04
   * @maximum 5400
   */
  size?: number;
  /** The font's PostScript name to be used to set the font for this layer. */
  fontPostScriptName?: string;
  color?: ColorDetails;
  /** The font's leading value, where leading is the distance between each line of text. */
  leading?: number;
  /** The font's tracking value, where tracking is the horizontal spacing between a range of characters. */
  tracking?: number;
  baseline?: BaselineType;
  fontCaps?: FontCaps;
  autoKern?: AutoKernType;
  /** Toggle strikethrough for selected text. */
  strikethrough?: boolean;
  /** Toggle bold for selected text. */
  syntheticBold?: boolean;
  /** Toggle italic for selected text. */
  syntheticItalic?: boolean;
  /** Toggle underlining of text. */
  underline?: boolean;
  /** Toggle text ligature, which are special characters in a font that combine two (or more). */
  ligature?: boolean;
  /** Toggle automatic formatting of fractions: numbers separated by a slash (such as 1/2). */
  fractions?: boolean;
  /** Toggle stylistic alternates, which formats stylized characters that create a purely aesthetic effect. */
  stylisticAlternates?: boolean;
  /**
   * The amount of vertical scaling to apply to the font.
   * @minimum 0
   * @maximum 1000
   */
  verticalScale?: number;
  /**
   * The amount of horizontal scaling to apply to the font.
   * @minimum 0
   * @maximum 1000
   */
  horizontalScale?: number;
}

/**
 * Paragraph style settings.
 */
export interface ParagraphStyleDetails {
  /** The paragraph alignment. */
  alignment?: ParagraphStyleAlignmentType;
  /** The amount of indent to add to the left margin. */
  startIndent?: number;
  /** The amount of indent to add to the right margin. */
  endIndent?: number;
  /** Toggle hyphenate for paragraph text. */
  hyphenate?: boolean;
  /** The amount of indent to add to the first line of the paragraph. */
  firstLineIndent?: number;
  /** The amount of space to add before the paragraph. */
  spaceBefore?: number;
  /** The amount of space to add after the paragraph. */
  spaceAfter?: number;
}

/**
 * An object describing the input mask replaced or added to the layer.
 */
export interface LayerMaskDetails {
  /** Indicates if this is a clipped layer. */
  clip?: boolean;
  /** Indicates whether a mask is enabled on that layer. */
  enabled?: boolean;
  /** Indicates whether a mask is linked to the layer. */
  linked?: boolean;
  offset?: Offset;
}

/**
 * Offset details.
 */
export interface Offset {
  /** Offset to indicate horizontal move of the mask. */
  x?: number;
  /** Offset to indicate vertical move of the mask. */
  y?: number;
}

/**
 * Smart object details.
 */
export interface SmartObjectDetails {
  /** Desired image format for the smart object. */
  type?: string;
  /** Indicates if the smart object is linked. Currently we support embedded smart object only, which means "linked = false". */
  linked?: boolean;
  /** Name of the embedded or linked smart object. Currently we support embedded smart object only. */
  name?: string;
  /** Only for a linked smart object. Indicates the relative path for the linked smart object. */
  path?: string;
  /** Only for an embedded smart object. Indicates the instance ID of the embedded smart object. This ID is unique and the value is derived from the RAW data of the document. `instanceId` may show a value as unknown, if the embedded smart object is generated using a non-Adobe application. */
  instanceId?: string;
}

export interface FillDetails {
  solidColor?: SolidColor;
}

export interface SolidColor {
  rgb: RgbColor;
}

/**
 * An object describing the RGB color format in 8 bits.
 */
export interface RgbColor {
  /**
   * @minimum 0
   * @maximum 255
   */
  red?: number;
  /**
   * @minimum 0
   * @maximum 255
   */
  green?: number;
  /**
   * @minimum 0
   * @maximum 255
   */
  blue?: number;
}

/**
 * An object describing the RGB color format in 16 bits.
 */
export interface FontColorRgb {
  /**
   * @minimum 0
   * @maximum 32768
   */
  red?: number;
  /**
   * @minimum 0
   * @maximum 32768
   */
  green?: number;
  /**
   * @minimum 0
   * @maximum 32768
   */
  blue?: number;
}

/**
 * The font color settings for CMYK mode in 16-bit representation.
 */
export interface FontColorCmyk {
  /**
   * @minimum 0
   * @maximum 32768
   */
  cyan?: number;
  /**
   * @minimum 0
   * @maximum 32768
   */
  magenta?: number;
  /**
   * @minimum 0
   * @maximum 32768
   */
  yellowColor?: number;
  /**
   * @minimum 0
   * @maximum 32768
   */
  black?: number;
}

/**
 * The font color settings for gray mode in 16-bit representation.
 */
export interface FontColorGray {
  /**
   * @minimum 0
   * @maximum 32768
   */
  gray?: number;
}

/**
 * The font color settings for Lab mode in 16-bit representation.
 */
export interface FontColorLab {
  /**
   * @minimum 0
   * @maximum 32768
   */
  luminance?: number;
  /**
   * @minimum 0
   * @maximum 32768
   */
  a?: number;
  /**
   * @minimum 0
   * @maximum 32768
   */
  b?: number;
}

/**
 * Text settings.
 */
export interface TextLayerDetails {
  /** The text string. */
  content?: string;
  /** Character style settings. If the same supported attributes apply to all characters in the layer, then this will be an array of one item. Otherwise, each `characterStyle` object will have a 'from' and 'to' value indicating the range of characters that style applies to. */
  characterStyles?: TextLayerCharacterStyleDetails[];
  /** Paragraph style settings. If the same supported attributes apply to all characters in the layer then this will be an array of one item, otherwise each paragraph style object will have a 'from' and 'to' value indicating the range of characters that the style applies to. */
  paragraphStyles?: TextLayerParagraphStyleDetails[];
}

export interface TextLayerCharacterStyleDetails {
  /**
   * The beginning of the range of characters that this character style applies to. Based on initial index of 0. For example a style applied to only the first two characters would be from=0 and to=1.
   * @minimum 0
   */
  from?: number;
  /**
   * The ending of the range of characters that this character style applies to. Based on initial index of 0. For example a style applied to only the first two characters would be from=0 and to=1.
   * @minimum 0
   */
  to?: number;
  /** The font size in points. */
  fontSize?: number;
  /** The font's PostScript name from the [list of supported fonts](../../getting_started/technical_usage_notes/index.md#photoshop-api-supported-fonts). */
  fontName?: string;
  orientation?: OrientationType;
  fontColor?: FontColorDetails;
}

/**
 * If the same supported attributes apply to all characters in the layer then this will be an array of one item, otherwise each paragraph style object will have a 'from' and 'to' value indicating the range of characters that the style applies to.
 */
export interface TextLayerParagraphStyleDetails {
  /**
   * The beginning of the range of characters that this paragraph style applies to. Based on initial index of 0. For example a style applied to only the first two characters would be from=0 and to=1.
   * @minimum 0
   */
  from?: number;
  /**
   * The ending of the range of characters that this paragraph style applies to. Based on initial index of 0. For example a style applied to only the first two characters would be from=0 and to=1.
   * @minimum 0
   */
  to?: number;
  alignment?: AlignmentType;
}

/**
 * Blend options of a layer, including opacity and blend mode.
 */
export interface BlendDetails {
  /**
   * Indicates the opacity value of a layer.
   * @minimum 0
   * @maximum 100
   */
  opacity?: number;
  blendMode?: BlendModeType;
}

/**
 * The paragraph alignment.
 */
export type AlignmentType = (typeof AlignmentType)[keyof typeof AlignmentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AlignmentType = {
  left: 'left',
  center: 'center',
  right: 'right',
  justify: 'justify',
  justifyLeft: 'justifyLeft',
  justifyCenter: 'justifyCenter',
  justifyRight: 'justifyRight',
} as const;

/**
 * The paragraph alignment.
 */
export type ParagraphStyleAlignmentType =
  (typeof ParagraphStyleAlignmentType)[keyof typeof ParagraphStyleAlignmentType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ParagraphStyleAlignmentType = {
  left: 'left',
  center: 'center',
  right: 'right',
  justify: 'justify',
  justifyLeft: 'justifyLeft',
  justifyCenter: 'justifyCenter',
  justifyRight: 'justifyRight',
  justifyAll: 'justifyAll',
} as const;

/**
 * The text's aliasing type which determines the smoothness of the jagged edges of the text.
 */
export type AntiAliasType = (typeof AntiAliasType)[keyof typeof AntiAliasType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AntiAliasType = {
  antiAliasNone: 'antiAliasNone',
  antiAliasSharp: 'antiAliasSharp',
  antiAliasCrisp: 'antiAliasCrisp',
  antiAliasStrong: 'antiAliasStrong',
  antiAliasSmooth: 'antiAliasSmooth',
  antiAliasPlatformLCD: 'antiAliasPlatformLCD',
  antiAliasPlatformGray: 'antiAliasPlatformGray',
} as const;

/**
 * The text's kerning setting. Optical: set based on the shape of the font. Metrics: uses kern pairs included in fonts.
 */
export type AutoKernType = (typeof AutoKernType)[keyof typeof AutoKernType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AutoKernType = {
  opticalKern: 'opticalKern',
  metricsKern: 'metricsKern',
} as const;

/**
 * Based on type.
 */
export type BasedOnType = (typeof BasedOnType)[keyof typeof BasedOnType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BasedOnType = {
  transparentPixels: 'transparentPixels',
} as const;

/**
 * Indicates if the text is raised or lowered in relation to a font's baseline.
 */
export type BaselineType = (typeof BaselineType)[keyof typeof BaselineType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaselineType = {
  subScript: 'subScript',
  superScript: 'superScript',
} as const;

/**
 * Blend mode of layer.
 */
export type BlendModeType = (typeof BlendModeType)[keyof typeof BlendModeType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BlendModeType = {
  normal: 'normal',
  dissolve: 'dissolve',
  darken: 'darken',
  multiply: 'multiply',
  colorBurn: 'colorBurn',
  linearBurn: 'linearBurn',
  darkerColor: 'darkerColor',
  lighten: 'lighten',
  screen: 'screen',
  colorDodge: 'colorDodge',
  linearDodge: 'linearDodge',
  lighterColor: 'lighterColor',
  overlay: 'overlay',
  softLight: 'softLight',
  hardLight: 'hardLight',
  vividLight: 'vividLight',
  linearLight: 'linearLight',
  pinLight: 'pinLight',
  hardMix: 'hardMix',
  difference: 'difference',
  exclusion: 'exclusion',
  subtract: 'subtract',
  divide: 'divide',
  hue: 'hue',
  saturation: 'saturation',
  color: 'color',
  luminosity: 'luminosity',
} as const;

export interface CanvasSize {
  bounds: Bounds;
}

export interface ChannelDetails {
  channel?: ChannelType;
  /**
   * @minimum -180
   * @maximum 180
   */
  hue?: number;
  /**
   * @minimum -100
   * @maximum 100
   */
  saturation?: number;
  /**
   * @minimum -100
   * @maximum 100
   */
  lightness?: number;
}

/**
 * The channel type.
 */
export type ChannelType = (typeof ChannelType)[keyof typeof ChannelType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChannelType = {
  master: 'master',
} as const;

/**
 * Font color in RGB format.
 */
export interface ColorDetails {
  /**
   * The color red value.
   * @minimum 0
   * @maximum 65535
   */
  red: number;
  /**
   * The color green value.
   * @minimum 0
   * @maximum 65535
   */
  green: number;
  /**
   * The color blue value.
   * @minimum 0
   * @maximum 65535
   */
  blue: number;
}

/**
 * Desired PNG compression level.
 */
export type CompressionType = (typeof CompressionType)[keyof typeof CompressionType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompressionType = {
  small: 'small',
  medium: 'medium',
  large: 'large',
} as const;

/**
 * Bit depth. This is either 8, 16 or 32 bit.
 */
export type DepthType = (typeof DepthType)[keyof typeof DepthType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DepthType = {
  NUMBER_8: 8,
  NUMBER_16: 16,
  NUMBER_32: 32,
} as const;

export interface OperationDocument {
  canvasSize?: CanvasSize;
  imageSize?: ImageSize;
  trim?: Trim;
}

export type EastAsianFeaturesTextStyle = TextStyleType & unknown;

/**
 * Text features specifically for East Asian languages.
 */
export interface EastAsianFeatures {
  textStyle?: EastAsianFeaturesTextStyle;
}

/**
 * Error details.
 */
export interface ErrorDetails {
  /** The parameter name. */
  name?: string;
  /** The error. */
  reason?: string;
}

/**
 * Type of fill for the background layer.
 */
export type FillType = (typeof FillType)[keyof typeof FillType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FillType = {
  white: 'white',
  backgroundColor: 'backgroundColor',
  transparent: 'transparent',
} as const;

/**
 * Focal selector.
 */
export interface FocalSelector {
  /** X coordinate. */
  x?: number;
  /** Y coordinate. */
  y?: number;
}

/**
 * The text's capitalization values.
 */
export type FontCaps = (typeof FontCaps)[keyof typeof FontCaps];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FontCaps = {
  allCaps: 'allCaps',
  smallCaps: 'smallCaps',
} as const;

export type FontColorDetailsRgb = FontColorRgb & unknown;

export type FontColorDetailsCmyk = FontColorCmyk & unknown;

export type FontColorDetailsGray = FontColorGray & unknown;

export type FontColorDetailsLab = FontColorLab & unknown;

export interface FontColorDetails {
  rgb?: FontColorDetailsRgb;
  cmyk?: FontColorDetailsCmyk;
  gray?: FontColorDetailsGray;
  lab?: FontColorDetailsLab;
}

/**
 * Soft mask or binary mask.
 */
export type MaskFormatType = (typeof MaskFormatType)[keyof typeof MaskFormatType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MaskFormatType = {
  binary: 'binary',
  soft: 'soft',
} as const;

/**
 * The image mode.
 */
export type ImageModeType = (typeof ImageModeType)[keyof typeof ImageModeType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ImageModeType = {
  grayscale: 'grayscale',
  rgb: 'rgb',
  cmyk: 'cmyk',
} as const;

/**
 * The size of the image
 */
export interface ImageSize {
  width: number;
  height: number;
}

export type DocumentCreateLayerInput = StorageDetails & unknown;

export type DocumentCreateLayerSmartObject = SmartObject & unknown;

export type DocumentCreateLayerText = TextLayerDetails & unknown;

export type DocumentCreateLayerBlendOptions = BlendDetails & unknown;

export interface DocumentCreateLayer {
  type: LayerType;
  input: DocumentCreateLayerInput;
  name?: string;
  /** is the layer locked */
  locked?: boolean;
  /** is the layer visible */
  visible?: boolean;
  adjustments?: AdjustmentDetails;
  bounds?: Bounds;
  children?: ChildrenLayerDetails[];
  mask?: MaskDetails;
  smartObject?: DocumentCreateLayerSmartObject;
  fill?: FillDetails;
  text?: DocumentCreateLayerText;
  blendOptions?: DocumentCreateLayerBlendOptions;
}

/**
 * Indicates the layer to edit, by it's ID or name. Note the object is currently empty but leaves room for further enhancements. The layer block should contain changes from the original manifest. If you apply it to a group layer, you will be affecting the attributes of the group layer itself, not the child layers. This edit is supported for layer type `smartObject` and `fillLayer` only.
 */
export type DocumentOperationLayerEdit = { [key: string]: unknown };

export type DocumentOperationLayerSmartObject = SmartObject & unknown;

export type DocumentOperationLayerText = TextLayerDetails & unknown;

export type DocumentOperationLayerBlendOptions = BlendDetails & unknown;

export interface DocumentOperationLayer {
  /** Indicates the layer to edit, by it's ID or name. Note the object is currently empty but leaves room for further enhancements. The layer block should contain changes from the original manifest. If you apply it to a group layer, you will be affecting the attributes of the group layer itself, not the child layers. This edit is supported for layer type `smartObject` and `fillLayer` only. */
  edit?: DocumentOperationLayerEdit;
  move?: MoveDetails;
  add?: LayerPosition;
  delete: DeleteDetails;
  /** The layer ID. */
  id: number;
  /** The layer index. Required when deleting a layer, otherwise not used. */
  index?: number;
  /** A tree of layer objects representing the PSD layer structure extracted from the PSD document. */
  children?: ChildrenLayerDetails[];
  type?: LayerType;
  input?: StorageDetails;
  name?: string;
  /** is the layer locked */
  locked?: boolean;
  /** is the layer visible */
  visible?: boolean;
  adjustments?: AdjustmentDetails;
  mask?: MaskDetails;
  bounds?: Bounds;
  smartObject?: DocumentOperationLayerSmartObject;
  fill?: FillDetails;
  text?: DocumentOperationLayerText;
  blendOptions?: DocumentOperationLayerBlendOptions;
  horizontalAlign?: HorizontalAlignType;
  verticalAlign?: VerticalAlignType;
  /** Indicates if the pixels need to proportionally fill into the entire canvas of the document. */
  fillToCanvas?: boolean;
}

export interface SmartObjectLayer {
  add?: LayerPosition;
  /** the layer id */
  id?: number;
  name?: string;
  /** is the layer locked */
  locked?: boolean;
  /** is the layer visible */
  visible?: boolean;
  input: StorageDetails;
  bounds?: Bounds;
}

export type TextOptionsLayerText = TextDetails & unknown;

export interface TextOptionsLayer {
  /** The name of the layer you want to insert. Use either ID or name. */
  name?: string;
  /** The ID of the layer you want to insert. Use either ID or name. */
  id?: number;
  bounds?: Bounds;
  /** Is the layer editable. */
  locked?: boolean;
  /** Is the layer visible. */
  visible?: boolean;
  text?: TextOptionsLayerText;
}

/**
 * The rendition links.
 */
export interface RenditionLinks {
  /** Array of rendition objects. */
  renditions?: RenditionLinkDetails[];
}

/**
 * Action to take if there are one or more missing fonts in the document. Using `fail` - the job will not succeed and the status will be set to `failed` with the details of the error provided in the `details` section in the status. Using `useDefault` - the job will succeed, however all the missing fonts will use the font: ArialMT.
 */
export type ManageMissingFonts = (typeof ManageMissingFonts)[keyof typeof ManageMissingFonts];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ManageMissingFonts = {
  useDefault: 'useDefault',
  fail: 'fail',
} as const;

export interface MaskFormat {
  format?: MaskFormatType;
}

export interface MaskDetails {
  input?: StorageDetails;
  /** Indicates if this is a clipped layer */
  clip?: boolean;
  /** Indicates a mask is enabled on that layer or not */
  enabled?: boolean;
  /** Indicates a mask is linked to the layer or not */
  linked?: boolean;
  offset?: Offset;
}

/**
 * The document's bit/channel depth.
 */
export type ChannelModeType = (typeof ChannelModeType)[keyof typeof ChannelModeType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChannelModeType = {
  bitmap: 'bitmap',
  greyscale: 'greyscale',
  indexed: 'indexed',
  rgb: 'rgb',
  cmyk: 'cmyk',
  hsl: 'hsl',
  hsb: 'hsb',
  multichannel: 'multichannel',
  duotone: 'duotone',
  lab: 'lab',
  xyz: 'xyz',
} as const;

export interface MoveDetails {
  moveChildren?: boolean;
  insertAbove?: LayerReference;
  insertBelow?: LayerReference;
  insertInto?: LayerReference;
  insertTop?: boolean;
  insertBottom?: boolean;
}

export type DocumentManifestOptionsThumbnails = Thumbnails & unknown;

/**
 * Available options to apply to all input files.
 */
export interface DocumentManifestOptions {
  thumbnails?: DocumentManifestOptionsThumbnails;
}

export type DocumentCreateOptionsManageMissingFonts = ManageMissingFonts & unknown;

export interface DocumentCreateOptions {
  manageMissingFonts?: DocumentCreateOptionsManageMissingFonts;
  /** The PostScript name of the font to be used as the global default for the document. If this font is also missing, the option specified in `manageMissingFonts` will take effect. */
  globalFont?: string;
  /** array of custom fonts needed in this document */
  fonts?: StorageDetails[];
  document: DocumentDetails;
  /** Array of layers to be created in the document. */
  layers?: DocumentCreateLayer[];
}

export type DocumentOperationOptionsManageMissingFonts = ManageMissingFonts & unknown;

export interface DocumentOperationOptions {
  manageMissingFonts?: DocumentOperationOptionsManageMissingFonts;
  /** The PostScript name of the font to be used as the global default. If this font is also missing, the option specified in `manageMissingFonts` will take effect */
  globalFont?: string;
  /** array of custom fonts needed in this document */
  fonts?: StorageDetails[];
  document?: OperationDocument;
  /** Array of layers to be created in the document. */
  layers?: DocumentOperationLayer[];
}

export interface SmartObjectOptions {
  /** Array of Smart Object layers to be created in the document */
  layers: SmartObjectLayer[];
}

export interface ActionOptions {
  /** Array of Photoshop Actions to play. */
  actions: Action[];
  /** array of custom pattern preset to be used in Photoshop Actions */
  patterns?: StorageDetails[];
  /** array of custom fonts needed in this document */
  fonts?: StorageDetails[];
  /** array of custom brushes needed in this document */
  brushes?: StorageDetails[];
}

export type ActionJsonOptionsActionJSONItem = { [key: string]: unknown };

export interface ActionJsonOptions {
  /** Array of Photoshop JSON-formatted Actions to play. */
  actionJSON: ActionJsonOptionsActionJSONItem[];
  /** array of custom pattern preset to be used in Photoshop Actions */
  patterns?: StorageDetails[];
  /** array of custom fonts needed in this document */
  fonts?: StorageDetails[];
  /** array of custom brushes needed in this document */
  brushes?: StorageDetails[];
  /**
   * Array of references to additional images, which can be referred by actionJson commands.
   * @minItems 1
   */
  additionalImages?: StorageDetails[];
}

/**
 * This block is needed only if you want to specify which action to convert from the ActionSet.
 */
export interface ActionJsonCreateOptions {
  /**
   * Array of action objects.
   * @minItems 1
   * @maxItems 1
   */
  actions: ActionDetails[];
}

export type CropOptionsUnit = UnitType & unknown;

export interface CropOptions {
  unit: CropOptionsUnit;
  /** The width to be added as padding. */
  width: number;
  /** The height to be added as padding. */
  height: number;
}

export type DepthBlurDetailsFocalSelector = FocalSelector & unknown;

export interface DepthBlurDetails {
  /**
   * The distance of the point to be in focus. 0 would be the nearest point, 100 would be the furthest point.
   * @minimum 0
   * @maximum 100
   */
  focalDistance?: number;
  /**
   * The range of the focal point.
   * @minimum 0
   * @maximum 100
   */
  focalRange?: number;
  focalSelector?: DepthBlurDetailsFocalSelector;
  /** If enabled uses select subject to automatically select the prominent subject for focus. Also would override focalDistance. */
  focusSubject?: boolean;
  /**
   * The amount of blur to apply.
   * @minimum 0
   * @maximum 100
   */
  blurStrength?: number;
  /**
   * The amount of haze to apply.
   * @minimum 0
   * @maximum 100
   */
  haze?: number;
  /**
   * The value of the temperature to apply. -50 would be coldest and 50 would be the warmest setting.
   * @minimum -50
   * @maximum 50
   */
  temp?: number;
  /**
   * The amount of the tint to apply.
   * @minimum -50
   * @maximum 50
   */
  tint?: number;
  /**
   * The amount of the saturation to apply. -50 implies fully unsaturated colors and 50 will fully saturate the colors.
   * @minimum -50
   * @maximum 50
   */
  saturation?: number;
  /**
   * The amount of the brightness to apply.
   * @minimum -50
   * @maximum 50
   */
  brightness?: number;
  /**
   * The amount of the graining to add to the image.
   * @minimum 0
   * @maximum 100
   */
  grain?: number;
}

export type TextOptionsManageMissingFonts = ManageMissingFonts & unknown;

export interface TextOptions {
  manageMissingFonts?: TextOptionsManageMissingFonts;
  /** The PostScript name of the font to be used as the global default. If this font is also missing, the option specified in `manageMissingFonts` will take effect */
  globalFont?: string;
  /**
   * Array of text layer objects you wish to act upon.
   * @minItems 1
   */
  layers: TextOptionsLayer[];
  /** Array of custom fonts needed in this document. */
  fonts?: StorageDetails[];
}

export interface ArtboardDetails {
  /** An array of hashes describing the input files to edit. Each input object will be either 'external', 'adobe', 'azure' or 'dropbox'. */
  artboard: StorageDetails[];
}

/**
 * The text orientation.
 */
export type OrientationType = (typeof OrientationType)[keyof typeof OrientationType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrientationType = {
  horizontal: 'horizontal',
  vertical: 'vertical',
} as const;

export interface ManifestJobStatusOutputDetails {
  /** the original input href */
  input?: string;
  /** Created timestamp of the job (YYYY-DD-MMThh:mm:ss.mmmmmZ) */
  created?: string;
  /** Modified timestamp of the job (YYYY-DD-MMThh:mm:ss.mmmmmZ) */
  modified?: string;
  status?: JobStatus;
  document?: ManifestJobDocumentDetails;
  /** A tree of layer objects representing the PSD layer structure extracted from the PSD document. */
  layers?: LayerDetails[];
}

export interface JobOutputDetails {
  /** the original input href */
  input?: string;
  /** Created timestamp of the job (YYYY-DD-MMThh:mm:ss.mmmmmZ) */
  created?: string;
  /** Modified timestamp of the job (YYYY-DD-MMThh:mm:ss.mmmmmZ) */
  modified?: string;
  status?: JobOutputStatus;
  _links?: RenditionLinks;
}

/**
 * The name of the color profile.
 */
export type ColorProfileType = (typeof ColorProfileType)[keyof typeof ColorProfileType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ColorProfileType = {
  'Adobe_RGB_(1998)': 'Adobe RGB (1998)',
  Apple_RGB: 'Apple RGB',
  ColorMatch_RGB: 'ColorMatch RGB',
  'sRGB_IEC61966-21': 'sRGB IEC61966-2.1',
  'Dot_Gain_10%': 'Dot Gain 10%',
  'Dot_Gain_15%': 'Dot Gain 15%',
  'Dot_Gain_20%': 'Dot Gain 20%',
  'Dot_Gain_25%': 'Dot Gain 25%',
  'Dot_Gain_30%': 'Dot Gain 30%',
  Gray_Gamma_18: 'Gray Gamma 1.8',
  Gray_Gamma_22: 'Gray Gamma 2.2',
} as const;

/**
 * Self link.
 */
export interface SelfLink {
  /** Job Status URL. */
  href?: string;
}

/**
 * An object describing the attributes specific to creating or editing a smart object. `SmartObject` properties operate on the input smart object file. When creating a linked smart object, this is a required. When creating an embedded smart object, it is optional.
 */
export interface SmartObject {
  /** Indicates if this Smart Object is linked. Currently we support Embedded Smart Object only which means "linked = false". */
  linked?: boolean;
}

/**
 * Job status.
 */
export type JobStatus = (typeof JobStatus)[keyof typeof JobStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobStatus = {
  pending: 'pending',
  running: 'running',
  succeeded: 'succeeded',
  failed: 'failed',
} as const;

/**
 * The child job status. Using `pending` - the request has been accepted and is waiting to start. Using `running` - the child job is running. Using `uploading` - files have been generated and are uploading to destination. Using `succeeded` - the child job has succeeded. Using `failed` - the child job has failed.
 */
export type JobOutputStatus = (typeof JobOutputStatus)[keyof typeof JobOutputStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobOutputStatus = {
  pending: 'pending',
  running: 'running',
  uploading: 'uploading',
  succeeded: 'succeeded',
  failed: 'failed',
} as const;

/**
 * Storage platforms supported.
 */
export type StorageType = (typeof StorageType)[keyof typeof StorageType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StorageType = {
  external: 'external',
  azure: 'azure',
  dropbox: 'dropbox',
} as const;

export type TextDetailsAntiAlias = AntiAliasType & unknown;

export type TextDetailsEastAsianFeatures = EastAsianFeatures & unknown;

export type TextDetailsTextType = TextType & unknown;

/**
 * Supported text layer attributes.
 */
export interface TextDetails {
  /** The content of the text layer. */
  content?: string;
  orientation?: OrientationType;
  /**
   * The text's rotation in angle.
   * @minimum -180
   * @maximum 180
   */
  rotate?: number;
  antiAlias?: TextDetailsAntiAlias;
  eastAsianFeatures?: TextDetailsEastAsianFeatures;
  /**
   * Array of character style objects. Any of the `characterStyles` property is required.
   * @minItems 1
   */
  characterStyles?: CharacterStyleDetails[];
  /**
   * Array of paragraph style objects. Any of the `paragraphStyles` properties is required.
   * @minItems 1
   */
  paragraphStyles?: ParagraphStyleDetails[];
  textType?: TextDetailsTextType;
}

/**
 * Base line direction for text style.
 */
export type TextStyleType = (typeof TextStyleType)[keyof typeof TextStyleType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TextStyleType = {
  cross: 'cross',
  rotated: 'rotated',
  withSream: 'withSream',
} as const;

/**
 * The type of text's contents, point or paragraph.
 */
export type TextType = (typeof TextType)[keyof typeof TextType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TextType = {
  point: 'point',
  paragraph: 'paragraph',
} as const;

export type ThumbnailsType = ThumbnailType & unknown;

/**
 * Include pre-signed GET URLs to small preview thumbnails for any renderable layer.
 */
export interface Thumbnails {
  type?: ThumbnailsType;
}

export interface Trim {
  basedOn: BasedOnType;
}

/**
 * Use this if the renditions needs to be of Canvas size. Using `True` trims the renditions to Canvas size, while `False` makes the renditions Layer Size.
 */
export type TrimToCanvasType = boolean;

/**
 * The desired image format. Using `image/vnd.adobe.photoshop` - create a new PSD file. Using `image/jpeg`, `image/png`, `image/tiff` - create a new JPEG, PNG or TIFF rendition. Certain image modes (RGB, CMYK, greyscale, etc.) must be converted to another image mode before a rendition can be created. With TIFF requested, Multichannel and Duotone will convert to RGB. With PNG requested, CMYK, HSL, HSB, Multichannel, Duotone, Lab and XYZ will convert to RGB.
 */
export type ImageFormatType = (typeof ImageFormatType)[keyof typeof ImageFormatType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ImageFormatType = {
  'image/vndadobephotoshop': 'image/vnd.adobe.photoshop',
  'image/jpeg': 'image/jpeg',
  'image/png': 'image/png',
  'image/tiff': 'image/tiff',
  vndadobephotoshop: 'vnd.adobe.photoshop',
} as const;

/**
 * The layer type. Using `layer` - a pixel layer. Using `textLayer` - a text layer. Using `adjustmentLayer` - an adjustment layer. Using `layerSection` - a grouping layer. Using `smartObject` - a smart object. Using `backgroundLayer` - a background layer. Using `fillLayer` - a fill layer.
 */
export type LayerType = (typeof LayerType)[keyof typeof LayerType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LayerType = {
  layer: 'layer',
  textLayer: 'textLayer',
  adjustmentLayer: 'adjustmentLayer',
  smartObject: 'smartObject',
  fillLayer: 'fillLayer',
  backgroundLayer: 'backgroundLayer',
  layerSection: 'layerSection',
} as const;

/**
 * Desired image format.
 */
export type ThumbnailType = (typeof ThumbnailType)[keyof typeof ThumbnailType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ThumbnailType = {
  'image/jpeg': 'image/jpeg',
  'image/png': 'image/png',
  'image/tiff': 'image/tiff',
} as const;

/**
 * Unit for width and height.
 */
export type UnitType = (typeof UnitType)[keyof typeof UnitType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UnitType = {
  Pixels: 'Pixels',
  Percent: 'Percent',
} as const;

/**
 * Indicates the relative horizontal position of the layer with respect to the canvas of the document.
 */
export type HorizontalAlignType = (typeof HorizontalAlignType)[keyof typeof HorizontalAlignType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HorizontalAlignType = {
  left: 'left',
  center: 'center',
  right: 'right',
} as const;

/**
 * Indicates the relative vertical position of the layer with respect to the canvas of the document.
 */
export type VerticalAlignType = (typeof VerticalAlignType)[keyof typeof VerticalAlignType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VerticalAlignType = {
  top: 'top',
  center: 'center',
  bottom: 'bottom',
} as const;

export interface UrlResource {
  /** The URL of the resource. Only these listed domains are accepted in the request:  
  <ul><li><code>amazonaws.com</code></li><li><code>windows.net</code></li><li><code>dropboxusercontent.com</code></li><li><code>assets.frame.io</code></li><li><code>storage.googleapis.com</code></li></ul> */
  url: string;
}

export interface RemoveBgInputImage {
  /** The source path for the input image. Dimensions of the image should not be greater than 6000px X 6000px. The image media type must be `image/jpeg`, `image/png`, `image/webp`, or `image/tiff`. */
  source: UrlResource;
}

/**
 * The mode of background removal.
 */
export type RemoveBgMode = (typeof RemoveBgMode)[keyof typeof RemoveBgMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RemoveBgMode = {
  cutout: 'cutout',
  mask: 'mask',
  psd: 'psd',
} as const;

/**
 * The media type of the output image. By default this will match the input source file format.
 */
export type RemoveBgOutputImageMediaType =
  (typeof RemoveBgOutputImageMediaType)[keyof typeof RemoveBgOutputImageMediaType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RemoveBgOutputImageMediaType = {
  'image/jpeg': 'image/jpeg',
  'image/png': 'image/png',
  'image/webp': 'image/webp',
  'image/vndadobephotoshop': 'image/vnd.adobe.photoshop',
} as const;

export interface RemoveBgOutputImageOptions {
  mediaType?: RemoveBgOutputImageMediaType;
}

export interface RemoveBgColor {
  /**
   * The red value of the color.
   * @minimum 0
   * @maximum 255
   */
  red: number;
  /**
   * The green value of the color.
   * @minimum 0
   * @maximum 255
   */
  green: number;
  /**
   * The blue value of the color.
   * @minimum 0
   * @maximum 255
   */
  blue: number;
  /**
   * The transparency value. 0 is fully transparent and 1 is fully opaque.
   * @minimum 0
   * @maximum 1
   */
  alpha: number;
}

export interface RemoveBackgroundV2Request {
  /** The image to be processed. */
  image: RemoveBgInputImage;
  mode?: RemoveBgMode;
  /** The options for the output image. */
  output?: RemoveBgOutputImageOptions;
  /** If true, the image returned is cropped to the cutout border. Transparent pixels are removed. */
  trim?: boolean;
  /** The background color. */
  backgroundColor?: RemoveBgColor;
  /**
   * If the value is greater than 0, automatically removes colored reflections that have been left on the main subject by the background.
   * @minimum 0
   * @maximum 1
   */
  colorDecontamination?: number;
}

export interface JobLinkResponse {
  /** The job ID for the asynchronous job. */
  jobId: string;
  /** The URL to check the status of the asynchronous job. */
  statusUrl: string;
}

export interface JobStatusPollPayload {
  status: JobStatus;
  /** The job ID. */
  jobId: string;
}

export type JobStatusSucceededResponseStatus =
  (typeof JobStatusSucceededResponseStatus)[keyof typeof JobStatusSucceededResponseStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobStatusSucceededResponseStatus = {
  succeeded: 'succeeded',
} as const;

export type JobStatusSucceededResponseResultOutputsItemDestination = {
  /** The output URL */
  url?: string;
};

export type JobStatusSucceededResponseResultOutputsItem = {
  destination?: JobStatusSucceededResponseResultOutputsItemDestination;
  /** The media type of the output */
  mediaType?: string;
};

export type JobStatusSucceededResponseResult = {
  outputs?: JobStatusSucceededResponseResultOutputsItem[];
};

export interface JobStatusSucceededResponse {
  status: JobStatusSucceededResponseStatus;
  /** The job ID. */
  jobId: string;
  result: JobStatusSucceededResponseResult;
}

export interface FillMaskedAreasInputImage {
  /** The source of the input image. Dimensions of the image should not be greater than (4000px X 4000px). */
  source: UrlResource;
}

export interface FillMaskedAreasRequest {
  /** The image to be processed. */
  image: FillMaskedAreasInputImage;
  /** The areas of the image represented by this list of masks will be inpainted. */
  masks: FillMaskedAreasInputImage[];
}

/**
 * The media type of the input image.
 */
export type MaskBodyPartsImageMediaType =
  (typeof MaskBodyPartsImageMediaType)[keyof typeof MaskBodyPartsImageMediaType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MaskBodyPartsImageMediaType = {
  'image/jpeg': 'image/jpeg',
  'image/png': 'image/png',
} as const;

export interface MaskBodyPartsInputImage {
  /** The source of the input image. Dimensions of the image should not be greater than (4000px X 4000px). */
  source: UrlResource;
}

/**
 * The media type of the mask.
 */
export type MaskBodyPartsMaskMediaType =
  (typeof MaskBodyPartsMaskMediaType)[keyof typeof MaskBodyPartsMaskMediaType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MaskBodyPartsMaskMediaType = {
  'image/png': 'image/png',
} as const;

export interface MaskBodyPartsInputMask {
  /** The URL of the mask. Dimensions of the mask should not be greater than (4000px X 4000px). */
  source: UrlResource;
}

export interface MaskBodyPartsRequest {
  /** The input image. */
  image: MaskBodyPartsInputImage;
  /** The mask of the subject in the input image. */
  mask: MaskBodyPartsInputMask;
}

/**
 * The media type of the input image.
 */
export type MaskObjectsInputImageMediaType =
  (typeof MaskObjectsInputImageMediaType)[keyof typeof MaskObjectsInputImageMediaType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MaskObjectsInputImageMediaType = {
  'image/jpeg': 'image/jpeg',
  'image/png': 'image/png',
} as const;

export interface MaskObjectsInputImage {
  /** The source of the input image. Dimensions of the image should not be greater than (4000px X 4000px). */
  source: UrlResource;
}

export interface MaskObjectsRequest {
  /** The input image. */
  image: MaskObjectsInputImage;
}

/**
 * The media type of the input image.
 */
export type RefineMaskImageMediaType =
  (typeof RefineMaskImageMediaType)[keyof typeof RefineMaskImageMediaType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefineMaskImageMediaType = {
  'image/jpeg': 'image/jpeg',
  'image/png': 'image/png',
} as const;

export interface RefineMaskInputImage {
  /** The source of the input image. Dimensions of the image should not be greater than (4000px X 4000px). */
  source: UrlResource;
}

export interface RefineMaskRequest {
  /** The input image. */
  image: RefineMaskInputImage;
  /** The mask in the input image that needs to be refined. */
  mask: RefineMaskInputImage;
  /** When `true`, this returns an RGBA image where the masked area has been further refined with color decontamination. A `false` value (default) means that the output will simply be the refined mask. */
  colorDecontamination?: boolean;
}

/**
 * Media type of the output image.
 */
export type OutputImageDetailsMediaType =
  (typeof OutputImageDetailsMediaType)[keyof typeof OutputImageDetailsMediaType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OutputImageDetailsMediaType = {
  'image/jpeg': 'image/jpeg',
  'image/png': 'image/png',
} as const;

export interface OutputImageDetails {
  /** Details of the location where the output image is located. */
  destination: UrlResource;
  /** Media type of the output image. */
  mediaType: OutputImageDetailsMediaType;
}

export interface FillMaskedAreasJobApiResponse {
  status: JobStatus;
  /** The job ID. */
  jobId: string;
  /** The output image. */
  image: OutputImageDetails;
}

export interface ImageBoundingBox {
  /** The x coordinate of the upper-left corner of the bounding box. The origin (0,0) is at the upper-left corner of the image. */
  x: number;
  /** The y coordinate of the upper-left corner of the bounding box. The origin (0,0) is at the upper-left corner of the image. */
  y: number;
  /** The width of the bounding box, starting from the x coordinate. */
  width: number;
  /** The height of the bounding box, starting from the y coordinate. */
  height: number;
}

/**
 * Media type of the mask of the identified body part.
 */
export type MaskBodyPartsOutputImageMediaType =
  (typeof MaskBodyPartsOutputImageMediaType)[keyof typeof MaskBodyPartsOutputImageMediaType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MaskBodyPartsOutputImageMediaType = {
  'image/png': 'image/png',
} as const;

export interface MaskBodyPartsOutputImage {
  /** The label of the identified body part. */
  label: string;
  /** The bounding box of the identified body part. */
  boundingBox: ImageBoundingBox;
  /** The probability or confidence score of the match. */
  score: number;
  /** Details of the location where the mask of the identified body part is located. */
  destination: UrlResource;
  /** Media type of the mask of the identified body part. */
  mediaType: MaskBodyPartsOutputImageMediaType;
}

export interface MaskBodyPartsJobApiResponse {
  status: JobStatus;
  /** The job ID. */
  jobId: string;
  /** An array of output image masks. */
  masks: MaskBodyPartsOutputImage[];
}

/**
 * Media type of the mask.
 */
export type MaskObjectsOutputImageMediaType =
  (typeof MaskObjectsOutputImageMediaType)[keyof typeof MaskObjectsOutputImageMediaType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MaskObjectsOutputImageMediaType = {
  'image/png': 'image/png',
} as const;

export interface MaskObjectsOutputImage {
  /** The label of the identified object or area of interest. */
  label: string;
  /** The bounding box of the object or area of interest. */
  boundingBox: ImageBoundingBox;
  /** The probability or confidence score of the match. */
  score: number;
  /** Details of the location where the mask is located. */
  destination: UrlResource;
  /** Media type of the mask. */
  mediaType: MaskObjectsOutputImageMediaType;
}

export interface MaskObjectsJobApiResponse {
  status: JobStatus;
  /** The job ID. */
  jobId: string;
  /** List of masks representing foreground objects. */
  semanticMasks: MaskObjectsOutputImage[];
  /** List of masks representing background regions. */
  backgroundMasks: MaskObjectsOutputImage[];
}

/**
 * Media type of the refined mask or image.
 */
export type RefineMaskOutputImageMediaType =
  (typeof RefineMaskOutputImageMediaType)[keyof typeof RefineMaskOutputImageMediaType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefineMaskOutputImageMediaType = {
  'image/jpeg': 'image/jpeg',
  'image/png': 'image/png',
} as const;

export interface RefineMaskOutputImage {
  /** Details of the location where the refined mask or image is located. */
  destination: UrlResource;
  /** Media type of the refined mask or image. */
  mediaType: RefineMaskOutputImageMediaType;
  /** The bounding box of the refined mask or image. */
  boundingBox: ImageBoundingBox;
}

export interface RefineMaskJobApiResponse {
  status: JobStatus;
  /** The job ID. */
  jobId: string;
  /** The refined mask. This will only be attached to the response when mask is specified as an input. Only applicable when colorDecontamination is false. */
  mask?: RefineMaskOutputImage;
  /** The image with color decontamination. This will only be attached to the response when mask is specified as an input. Only applicable when colorDecontamination is true. */
  image?: RefineMaskOutputImage;
}

/**
 * The results of the job if completed.
 */
export type JobStatusResponseResults = { [key: string]: unknown };

export interface JobStatusResponse {
  status: JobStatus;
  /** The results of the job if completed. */
  results: JobStatusResponseResults;
}

/**
 * The status of the job.
 */
export type JobStatusRunningStatus =
  (typeof JobStatusRunningStatus)[keyof typeof JobStatusRunningStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobStatusRunningStatus = {
  running: 'running',
} as const;

/**
 * Response when a job is currently being processed. The job has started but is not yet complete.
 */
export interface JobStatusRunning {
  /** The job ID. */
  jobId: string;
  /** The status of the job. */
  status: JobStatusRunningStatus;
}

/**
 * The status of the job.
 */
export type JobStatusSucceededStatus =
  (typeof JobStatusSucceededStatus)[keyof typeof JobStatusSucceededStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobStatusSucceededStatus = {
  succeeded: 'succeeded',
} as const;

/**
 * Response when a job has completed successfully. In addition to the jobId and status, the response includes the results of the job which vary depending on the operation.
 */
export interface JobStatusSucceeded {
  /** The job ID. */
  jobId: string;
  /** The status of the job. */
  status: JobStatusSucceededStatus;
}

/**
 * The status of the job.
 */
export type JobStatusFailedStatus =
  (typeof JobStatusFailedStatus)[keyof typeof JobStatusFailedStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobStatusFailedStatus = {
  failed: 'failed',
} as const;

/**
 * Response when a job has failed during processing. Contains error details explaining what went wrong.
 */
export interface JobStatusFailed {
  /** The job ID. */
  jobId: string;
  /** The status of the job. */
  status: JobStatusFailedStatus;
  /** The error code. */
  error_code: string;
  /** The error message. */
  message: string;
}

/**
 * The status of the job.
 */
export type JobStatusNotStartedStatus =
  (typeof JobStatusNotStartedStatus)[keyof typeof JobStatusNotStartedStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobStatusNotStartedStatus = {
  not_started: 'not_started',
} as const;

/**
 * Response when a job has been created but processing has not yet begun. This status indicates the job is queued and waiting to start.
 */
export interface JobStatusNotStarted {
  /** The job ID. */
  jobId: string;
  /** The status of the job. */
  status: JobStatusNotStartedStatus;
}

export type SenseiJobStatusPathParameters = {
  jobId: string;
};
export type FacadeJobStatusPathParameters = {
  jobId: string;
};
export type FacadeJobStatus200 = JobStatusPollPayload | JobStatusSucceededResponse;

export type PsJobStatusPathParameters = {
  jobId: string;
};
export type GetJobStatusPathParameters = {
  jobId: string;
};
/**
 * The schema of a 200 response varies depending on the status of the job. A job with a `succeeded` status will include the results in the response. Result objects vary depending on the operation.
 */
export type GetJobStatus200 =
  | JobStatusNotStarted
  | JobStatusRunning
  | JobStatusSucceeded
  | JobStatusFailed;
